import React from "react";

import Flex from "../../components/base/flex";
import Text from "../../components/base/text";
import Link from "../../components/base/link";
import { teal, white } from "../../components/base/colors";
import Section from "../../components/section";

const SignUpCTA = () => (
  <Section justifyContent="center" backgroundColor={teal} padding="28px">
    <Flex width="633px" flexDirection="column" alignItems="center">
      <Text
        paddingBottom="18px"
        fontSize="30px"
        variant="strong"
        as="h6"
        color={white}
        textAlign="center"
      >
        Stay in the know about FUROSCIX
      </Text>
      <Link
        variant="solidButtonLightBlue"
        width={["100%", "390px", "390px"]}
        marginBottom="13px"
        href="/hcp/stay-informed"
        fontSize="16px"
      >
        Sign Up
      </Link>
      <Text fontSize="14px" textAlign="center" color={white}>
        By signing up, I agree to receive communications from scPharmaceuticals
        Inc, and I understand that my information will be used in accordance
        with the scPharmaceuticals{" "}
        <Link
          as="a"
          href="https://www.scpharmaceuticals.com/privacy-policy/"
          aria-label="opens privacy policy page in a new tab"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        .
      </Text>
    </Flex>
  </Section>
);

export default SignUpCTA;
